import React from 'react'
import {
  AllergyBenefitsRoot,
  Header,
  AllergyBenefitsContainer,
  ButtonWrapper,
} from './AllergyBenefits.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import allergyImg from '../../../../../public/assets/home/live-better.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Link from 'next/link'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'
export const AllergyBenefits: React.FC = () => {
  const { t } = useTranslation()

  const AllergyCopy = () => (
    <Stack gap='3' direction='column'>
      <Text>
        <Trans i18nKey='raw-benefits:allergy-benefits.body.0' components={{ AllergyLink: <Link href='blog/the-ultimate-guide-to-feeding-dogs-with-skin-allergies' /> }} />
      </Text>
      <Text>
        <Trans i18nKey='raw-benefits:allergy-benefits.body.1' components={{ Bold: <Text weight='bold' />}} /></Text>
      <Text>{t('raw-benefits:allergy-benefits.body.2')}</Text>
      <Text> <Trans i18nKey='raw-benefits:allergy-benefits.body.3' components={{ GrainFreeLink: <Link href='blog/the-great-grain-debate-do-dogs-need-grains' />}} /></Text>
      <Text>{t('raw-benefits:allergy-benefits.body.4')}</Text>
      <Text>{t('raw-benefits:allergy-benefits.body.5')}</Text>
    </Stack>
  )

  return (
    <AllergyBenefitsRoot>
      <AllergyBenefitsContainer>
        <Header>{t('raw-benefits:allergy-benefits.title')}</Header>
        <ImageWithText
          copyColumn={<AllergyCopy />}
          imageSrc={allergyImg}
          imageAlt="raw-benefits:allergy-benefits.image-alt"
          imageSide="right"
        />
        <ButtonWrapper>
          <Link href="/meal-plan" passHref>
            <Button as="a" className="cta">{t('raw-benefits:hero.primary-cta')}</Button>
          </Link>
        </ButtonWrapper>
      </AllergyBenefitsContainer>
    </AllergyBenefitsRoot>
  )
}

AllergyBenefits.displayName = 'AllergyBenefits'
